import { IState } from "./state";
import * as api from '../api';
import { ActionTree, Store, ActionContext } from 'vuex';

type PayloadType = 'initApp' | 'setState' | 'search' | 'setFilter'
export type ActionPayload<ActionData> = {
	type: PayloadType,
	payload: ActionData
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;


// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
	type: 'initApp',
	payload: state
})


export const setFilter: ActionCreator<IState> = (state) => ({
	type: 'setFilter',
	payload: state
})

export const search: ActionCreator<undefined> = () => ({
	type: 'search',
	payload: undefined
})

// Action handlers
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}

const toggleFilterModalAction: ActionHandler<IState> = ({ commit, dispatch}, { payload }) => {
	commit({
		type: 'setFilterModal',
		payload
	})
}

const removeFilterModalAction: ActionHandler<IState> = ({ commit, dispatch}, { payload }) => {
	commit({
		type: 'removeFilterModal',
		payload
	})
}

const setFilterAction: ActionHandler<string> = ({ commit, dispatch }, { payload }) => {
	commit({
		type: 'setFilter',
		payload: payload
	})
}

const setFilterSearchAction: ActionHandler<string> = ({ commit, dispatch }, { payload }) => {
	commit({
		type: 'setFilter',
		payload: payload
	})
	dispatch({
		type: 'search',
		payload: true
	})
}

const clearFilterAction: ActionHandler<string> = ({ commit, dispatch }, { payload }) => {
	commit({
		type: 'clearFilter',
		payload: payload
	})
}

const setRangeFilterAction: ActionHandler<string> = ({ commit, dispatch }, { payload }) => {
	commit({
		type: 'setRangeFilter',
		payload: payload
	})
}

const searchAction: ActionHandler<boolean> = ({ commit, state }, { payload }) => {
	const currentFilter = state.filters.filter(filter => filter.current === true).map(filter => filter.name)
	const newSearch = payload
	api.search(state.endpoints.searchUrl, {
		query: state.query,
		filter:	currentFilter,
		date: state.date,
		amount: newSearch ? 0 : state.result.amount
	 })
	 .then((res: any) => {
		if(newSearch) {
			commit({
				type: 'setResult',
				payload: res
			})
			commit({
				type: 'updateFilterCount',
				payload: res
			})
			commit({
				type: 'removeFilterModal',
				payload: res
			})
		} else {
			commit({
				type: 'addResult',
				payload: res
			})
			commit({
				type: 'updateFilterCount',
				payload: res
			})
			commit({
				type: 'removeFilterModal',
				payload: res
			})
		}
	 })
}


const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	search: searchAction,
	setFilter: setFilterAction,
	setFilterModal: toggleFilterModalAction,
	setRangeFilter: setRangeFilterAction,
	clearFilter: clearFilterAction,
	removeFilterModal: removeFilterModalAction,
	setFilterSearch: setFilterSearchAction
}

export default actions;